import { render, staticRenderFns } from "./DetailContext.vue?vue&type=template&id=4e3a5e7e&scoped=true&"
import script from "./DetailContext.vue?vue&type=script&lang=js&"
export * from "./DetailContext.vue?vue&type=script&lang=js&"
import style0 from "./DetailContext.vue?vue&type=style&index=0&id=4e3a5e7e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3a5e7e",
  null
  
)

export default component.exports